// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import ElementUI from 'element-ui'
import App from './App';
import router from './router';

import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/global.css'
import '../static/css/my_style.css'
import 'element-ui/lib/theme-chalk/display.css';
import '../static/iconfont/iconfont.css' /*引入字体图标*/

// 富文本样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import adminApi from './util/common.js';
import vue_resource from 'vue-resource';
Vue.use(vue_resource)
// Vue.use(ElementUI)

// 路由守卫
router.beforeEach((to, from, next) => {
    if (to.path === '/Login') return next()
    // 获取token
    const token = sessionStorage.getItem('access-token')
    // 判断token的状态,取反则没有token，让用户去登录
    if (!token) return next('/Login')
    next()
})

//定义全局变量
Vue.prototype.adminApi = adminApi;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js